import { Col, Row } from 'antd';
import { SectionTitle, Title } from '../components/dashboard/styles';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import jobsService from '../services/jobs.service';
import { ButtonType, TAButton } from '../components';
import { AiOutlinePlus } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import { OutsourcingBenefitsSelector } from '../components/outsourcing-benefits';
import { OutsourcingJopPostsList } from '../containers';
import { OutsourcingBenefits } from '../enums';
import outsourcingService from '../services/outsourcing.service';
import { notifyError, notifySuccess } from '../utils/notification';
import { useTheme } from 'styled-components';

export const OutsourcingDashboard: React.FC = () => {
	const navigate = useNavigate();

	const theme = useTheme();
	const [pagination, setPagination] = useState({ page: 1, pageSize: 50 });

	const { data: paginatedOutsourcingJobPosts, isLoading } = useQuery({
		queryKey: ['outsourcingJobPosts', pagination.page, pagination.pageSize],
		queryFn: () => jobsService.getJobs({ page: pagination.page, pageSize: pagination.pageSize }),
		keepPreviousData: true
	});

	const {
		mutate: outsourcingRequestMutation,
		isSuccess: isOutsourceMutationSuccess,
		error: outsourcingMutationError
	} = useMutation({
		mutationKey: ['outsourcingRequest'],
		mutationFn: data => outsourcingService.addOutsourcingRequest(data)
	});

	const [selectedBenefits, setSelectedBenefits] = useState<OutsourcingBenefits[]>([]);

	const onOutsourcingSubmit = data => {
		const request = {
			...data,
			benefits: selectedBenefits
		};

		outsourcingRequestMutation(request);
		if (isOutsourceMutationSuccess) notifySuccess('Outsourcing request sent successfully');
		else notifyError((outsourcingMutationError as any).message);
	};

	return (
		<div className={`dashboard`} style={{ width: '95%' }} id="dashboard">
			<Row gutter={0} className="mb-3">
				<Col xs={24} className="text-start  d-flex flex-column mb-3 mb-md-0">
					<div className="d-flex justify-content-between">
						<SectionTitle>Outsourcing</SectionTitle>
						<TAButton
							btntype={ButtonType.GHOST}
							style={{ padding: '11px 20px', height: 'auto' }}
							onClick={() => navigate('/dashboard/add-job')}
						>
							<Title icon={<AiOutlinePlus size={20} />} button>
								Add Job
							</Title>
						</TAButton>
					</div>
					<Col xs={24} md={8} className="mb-3 mb-md-0">
						You have{' '}
						<span
							style={{
								color: theme.TA_GREEN,
								borderBottom: `2px dashed ${theme.TA_GREEN}`,
								fontSize: '16px',
								marginLeft: '5px'
							}}
						>
							{paginatedOutsourcingJobPosts?.pagination.total} jobs
						</span>
					</Col>
				</Col>
			</Row>
			<Row className="w-100 mt-5">
				<OutsourcingBenefitsSelector onBenefitsChange={setSelectedBenefits} />
			</Row>
			<h5 className="mt-5">Select your job</h5>
			<OutsourcingJopPostsList
				loading={isLoading}
				data={paginatedOutsourcingJobPosts?.data}
				pagination={paginatedOutsourcingJobPosts?.pagination}
				outSourcingBenefitsSelected={!!selectedBenefits.length}
				onOutsourceSubmit={onOutsourcingSubmit}
			/>
		</div>
	);
};
